/* eslint-disable */
import React from "react";
import { Box, Grid, Text } from "grommet";
import Popup from "../../components/HeMapboxUrbica/components/Popup";

const gridSpacing = ["auto", "1fr"];
const TableRow = ({ label, value }) => {
    return (
        <Grid columns={gridSpacing} className="tablerow" gap={{ column: "xsmall" }}>
            <Box pad={{ left: "small" }}>
                <Text size="xsmall">{label}</Text>
            </Box>
            <Box pad={{ right: "small" }} alignSelf="end">
                <Text weight={"bold"} size="xsmall" textAlign="end">
                    {value}
                </Text>
            </Box>
        </Grid>
    );
};
const CapacityLevel = ({ percentile }) => {
    let capacity;
    if (percentile <= 33.33) {
        capacity = "High";
    } else if (percentile > 33.33 && percentile < 66.66) {
        capacity = "Medium";
    } else {
        capacity = "Low";
    }
    return capacity;
};

const Tooltip = ({ hoveredEventState }) => {
    if (!hoveredEventState) return null;
    const props = hoveredEventState.features[0].properties;
    const rciColor = hoveredEventState.features[0].layer.paint["fill-color"];

    return (
        <Popup closeButton={false} closeOnClick={false} maxWidth="400px">
            <Box direction="column" fill="horizontal" elevation="large" width={{min:'325px'}}>
                <Box background={"dark-1"} pad={{ top: "xsmall", bottom: "xxsmall", horizontal: "small" }}>
                    <Text size={"medium"} weight="bolder">
                        {props.name}
                    </Text>
                </Box>

                <Box background={"dark-1"}>
                    <Box
                        pad={{ horizontal: "small", bottom: "2px" }}
                        background={{
                            color:
                                "rgba(" +
                                255 * rciColor.r +
                                "," +
                                255 * rciColor.g +
                                "," +
                                255 * rciColor.b +
                                "," +
                                255 * rciColor.a +
                                ")",
                        }}
                    >
                        <Text weight={"bolder"} color="light-1" size="xxsmall" style={{ textTransform: "uppercase" }}>
                            <CapacityLevel percentile={props.percent_rank} /> capacity
                        </Text>
                    </Box>
                </Box>

                {/* <Box background={"light-4"} pad={{ vertical: "xxsmall", horizontal: "small" }}>
                    <Text size="xsmall" weight={"bold"}>
                        Rural Capacity Index: {decimalFormatter_0.format(props.capacity_index_as_mean * 100)}{" "}
                        <Text size="xsmall" weight={"normal"}>
                            (out of 100)
                        </Text>
                    </Text>
                </Box> */}

                {props.percent_rank < 1 ? (
                    <Box pad={{ horizontal: "small", vertical: "small" }}>
                        <Text weight={"bold"} size="small">
                            Almost no communities in the nation have higher capacity.
                        </Text>
                    </Box>
                ) : props.percent_rank > 99 ? (
                    <Box pad={{ horizontal: "small", vertical: "small" }}>
                        <Text weight={"bold"} size="small">
                            Nearly all communities in the nation have higher capacity.
                        </Text>
                    </Box>
                ) : (
                    <Box
                        direction="row"
                        justify="center"
                        gap="xsmall"
                        pad={{ horizontal: "small", vertical: "small" }}
                        align="center"
                    >
                        <Box direction="row" align="center">
                            <Text size="xxlarge" weight={"bolder"} textAlign="left">
                                {decimalFormatter_0.format(props.percent_rank)}
                            </Text>
                            <Text size="xlarge">%</Text>
                        </Box>

                        <Box flex="shrink">
                            <Text size="xsmall">
                                of locations nationwide
                                <br />
                                have higher capacity.
                            </Text>
                        </Box>
                    </Box>
                )}

                <Box background={"light-4"} pad={{ vertical: "xxsmall", horizontal: "small" }}>
                    <Text size="xsmall" weight={"bold"}>
                        Components of Index
                    </Text>
                </Box>
                <TableRow
                    label={"County is metropolitan?"}
                    value={!("is_urban" in props) ? <DataNotAvailable /> : props.is_urban === 1 ? "Yes" : "No"}
                />
                <TableRow
                    label={"Has head of planning?"}
                    value={
                        !("has_head_of_planning" in props) ? (
                            <DataNotAvailable />
                        ) : props.has_head_of_planning === 1 ? (
                            "Yes"
                        ) : (
                            "No"
                        )
                    }
                />
                <TableRow
                    label={"Gov. job gain/loss per 1k people (2010 to 2022):"}
                    value={
                        "govt_emp_change" in props ? (
                            decimalFormatter_0.format(props.govt_emp_change)
                        ) : (
                            <DataNotAvailable />
                        )
                    }
                />
                <TableRow
                    label={"Has college or university?"}
                    value={
                        !("has_university" in props) ? <DataNotAvailable /> : props.has_university === 1 ? "Yes" : "No"
                    }
                />
                <TableRow
                    label={"Drive to city with >50k people (avg. minutes):"}
                    value={
                        !("drive_time" in props) ? (
                            <DataNotAvailable />
                        ) : props.drive_time < 30 ? (
                            "<30"
                        ) : props.drive_time < 60 ? (
                            "30-60"
                        ) : props.drive_time <= 120 ? (
                            "60-120"
                        ) : (
                            ">120"
                        )
                    }
                />
                <TableRow
                    label={"Population change (2010 to 2022):"}
                    value={
                        "population_change_per_capita" in props ? (
                            decimalFormatter_1.format(props.population_change_per_capita)
                        ) : (
                            <DataNotAvailable />
                        )
                    }
                />
                <TableRow
                    label={"Income stability score (0 to 100):"}
                    value={
                        "inv_income_stdev" in props ? (
                            decimalFormatter_0.format(props.inv_income_stdev * 100)
                        ) : (
                            <DataNotAvailable />
                        )
                    }
                />
                <TableRow
                    label={"Families below poverty level:"}
                    value={
                        "pct_families_in_poverty" in props ? (
                            percentFormatter.format(props.pct_families_in_poverty)
                        ) : (
                            <DataNotAvailable />
                        )
                    }
                />
                <TableRow
                    label={"Households with broadband:"}
                    value={
                        "pct_broadband" in props ? percentFormatter.format(props.pct_broadband) : <DataNotAvailable />
                    }
                />
                <TableRow
                    label={"People without health insurance:"}
                    value={
                        "pct_uninsured" in props ? percentFormatter.format(props.pct_uninsured) : <DataNotAvailable />
                    }
                />
                <TableRow
                    label={"Voter turnout:"}
                    value={
                        "pct_voter_turnout" in props ? (
                            percentFormatter.format(props.pct_voter_turnout)
                        ) : (
                            <DataNotAvailable />
                        )
                    }
                />
                <TableRow
                    label={"Adults with higher education:"}
                    value={
                        "pct_bachelor_or_higher" in props ? (
                            percentFormatter.format(props.pct_bachelor_or_higher)
                        ) : (
                            <DataNotAvailable />
                        )
                    }
                />

                {/* <Box background={"light-4"} pad={{vertical:"xxsmall", horizontal:"small"}}>
                    <Text size="small" textAlign="left">
                        This location has a RCI of {decimalFormatter_0.format(props.capacity_index_as_mean * 100)} (out of 100).
                    </Text>
                </Box> */}
            </Box>
        </Popup>
    );
};

const percentFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 0,
});
const decimalFormatter_0 = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 0,
});
const decimalFormatter_1 = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 1,
});

const DataNotAvailable = () => {
    return (
        <Text color="dark-4" size="small">
            n/a
        </Text>
    );
};

export default Tooltip;
